<template>
  <div class="preview">
    <div v-if="!noHeader" class="preview__header">
      {{ $t('components.SurveyInputFormPreview.preview') }}
    </div>
    <div class="preview__content">
      <img v-if="survey.basic.mediaImage" :src="survey.basic.mediaImage.url" alt="" class="preview__image">
      <div v-else class="preview__brandImage">
        <div class="preview__brandImage__icon">
          <Icon name="iconQuestion" />
        </div>
        <p>{{ $t('components.SurveyInputFormPreview.logoNote') }}</p>
      </div>
      <template v-if="survey.basic.showCoverForm">
        <p class="preview__title">{{ survey.basic.coverTitle }}</p>
        <p class="preview__description">{{ survey.basic.coverText }}</p>
      </template>
      <div class="preview__form">
        <div class="preview__items">
          <div v-for="(question, i) in survey.question.questions" :key="i">
            <div class="preview__item">
              <div class="preview__item__title">
                <div class="preview__item__title__number">
                  <span class="preview__item__question">{{ questionNumber(i) }}</span>
                </div>
                <div>
                  <p>{{ question.name }}</p>
                  <p v-if="question.description" class="preview__item__title__description">{{ question.description }}</p>
                </div>
              </div>
              <template v-if="question.questionType === 'one_line_text'">
                <div class="preview__label">
                  <span><span :class="{ 'preview__label--required': question.required }">{{ optionLabel(question.required) }}</span>入力してください</span>
                </div>
                <input type="text" class="preview__textField">
              </template>
              <template v-else-if="question.questionType === 'text'">
                <div class="preview__label">
                  <span><span :class="{ 'preview__label--required': question.required }">{{ optionLabel(question.required) }}</span>入力してください</span>
                </div>
                <textarea type="text" class="preview__textArea" />
              </template>
              <template v-else-if="question.questionType === 'radio'">
                <div class="preview__label">
                  <span><span :class="{ 'preview__label--required': question.required }">{{ optionLabel(question.required) }}</span>1つだけ選択してください</span>
                </div>
                <ul class="preview__radio">
                  <li v-for="(option, j) in question.options" :key="j">
                    <input :id="`radio_${ j }`" type="radio">
                    <label :for="`radio_${ j }`"><span>{{ option.name }}</span></label>
                  </li>
                </ul>
              </template>
              <template v-else-if="question.questionType === 'checkbox'">
                <div class="preview__label">
                  <span><span :class="{ 'preview__label--required': question.required }">{{ optionLabel(question.required) }}</span>複数選択可能です</span>
                </div>
                <ul class="preview__checkbox">
                  <li v-for="(option, j) in question.options" :key="j">
                    <input :id="`checkbox_${ j }`" type="checkbox">
                    <label :for="`checkbox_${ j }`"><span>{{ option.name }}</span></label>
                  </li>
                </ul>
              </template>
              <template v-else-if="question.questionType === 'date'">
                <div class="preview__label">
                  <span><span :class="{ 'preview__label--required': question.required }">{{ optionLabel(question.required) }}</span>入力してください</span>
                </div>
                <input type="date" class="preview__dateField">
              </template>
            </div>
          </div>
          <div v-if="survey.question.showNps" class="preview__item">
            <div class="preview__item__title">
              <div class="preview__item__title__number">
                <span class="preview__item__question">{{ questionNumber(survey.question.questions.length) }}</span>
              </div>
              <div>
                <p>{{ survey.question.nps.name }}</p>
                <p v-if="survey.question.nps.description" class="preview__item__title__description">{{ survey.question.nps.description }}</p>
              </div>
            </div>
            <div class="preview__label">
              <span><span :class="{ 'preview__label--required': survey.question.nps.required }">{{ optionLabel(survey.question.nps.required) }}</span>選択してください</span>
            </div>
            <div class="preview__range">
              <div class="preview__range__value">-</div>
              <input max="10" min="-1" step="1" type="range" value="-1">
              <ul class="preview__range__count">
                <li>-</li>
                <li v-for="i of 11" :key="i">{{ i - 1 }}</li>
              </ul>
              <div class="preview__range__label">
                <span>すすめる気はない</span>
                <span>すすめたい</span>
              </div>
            </div>
          </div>
          <div v-if="survey.basic.showEmailForm" class="preview__item">
            <p class="preview__item__title">
              <span>メールアドレス</span>
              <span class="preview__label">
                <span><span :class="{ 'preview__label--required': survey.basic.requiredEmail }">{{ optionLabel(survey.basic.requiredEmail) }}</span></span>
              </span>
            </p>
            <input type="text" class="preview__textField">
          </div>
        </div>
        <div class="preview__button">送信する</div>
        <p v-if="survey.basic.showEmailForm" class="preview__link">プライバシーポリシーはこちら</p>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './/Icon'

export default {
  name: 'SurveyInputFormPreview',
  components: {
    Icon,
  },
  props: {
    survey: {
      type: Object,
      required: true,
    },
    noHeader: {
      type: Boolean,
    },
  },
  methods: {
    optionLabel(required) {
      return required ? '必須' : '【任意】'
    },
    questionNumber(num) {
      return `Q${ num + 1 }.`
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
.preview {
  $root: #{&};
  pointer-events: none;
  cursor: not-allowed;
  &__header {
    padding: 16px 32px;
    border-bottom: 1px solid #E4E7EB;
  }
  &__content {
    padding: 24px 20px;
  }
  &__image {
    width: 100%;
  }
  &__brandImage {
    display: flex;
    align-items: center;
    width: 176px;
    height: 176px;
    margin: 16px auto 24px;
    padding: 16px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgb(0 0 0 / 6%);
    background: #F5F6F9;
    font-size: 12px;
    line-height: 1.5;
    &__icon {
      margin-right: 8px;
      svg {
        fill: #3A3B3F;
      }
    }
  }
  &__title {
    margin-top: 40px;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
  }
  &__description {
    margin-top: 6px;
    font-size: 14px;
    line-height: 1.71;
    white-space: pre-wrap;
    + #{$root}__button {
      margin-top: 40px;
    }
  }
  &__items {
    margin-top: 24px;
  }
  &__item {
    margin-top: 24px;
    padding: 24px;
    border-radius: 10px;
    background: #F4F4F4;
    &__title {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      font-weight: bold;
      font-size: 14px;
      line-height: 1.43;
      word-break: break-all;
      #{$root}__label {
        margin-left: 16px;
      }

      &__number {
        white-space: nowrap;
      }
      &__description {
        margin-top: 4px;
        font-weight: normal;
        font-size: 12px;
      }
    }
    &__question {
      flex: 0 0 auto;
      margin-right: 8px;
      color: $color-accent-primary;
    }
  }
  &__label {
    display: flex;
    justify-content: center;
    span {
      padding: 4px 6px;
      font-weight: bold;
      font-size: 10px;
      line-height: 1.2;
      white-space: nowrap;
    }
    &--required {
      background: $color-accent-primary;
      color: #FFF;
      padding: 4px;
      margin-right: 5px;
      border-radius: 4px;
    }
  }
  &__textField,
  &__textArea {
    display: block;
    width: 100%;
    margin-top: 16px;
    padding: 8px 12px;
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    background: #FFF;
    font-size: 16px;
  }
  &__textArea {
    height: 160px;
    resize: none;
  }
  &__range {
    margin-top: 40px;
    input {
      width: 100%;
      height: 8px;
      border: 0;
      border-radius: 4px;
      background-color: #E6E6E6;
      -webkit-appearance: none;
      appearance: none;
      outline: none;
      cursor: pointer;
      &::-webkit-slider-thumb {
        display: block;
        position: relative;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #FFF;
        -webkit-appearance: none;
        appearance: none;
        cursor: pointer;
        transition: .2s;
      }
    }
    &__value {
      margin-bottom: 24px;
      font-weight: bold;
      font-size: 24px;
      line-height: 1;
      text-align: center;
    }
    &__count {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
      li {
        width: 2em;
        color: #AAA;
        font-size: 10px;
        line-height: 1;
        text-align: center;
      }
    }
    &__label {
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      font-size: 10px;
      line-height: 1;
    }
  }
  &__radio,
  &__checkbox {
    margin-top: 16px;
    li + li {
      margin-top: 8px;
    }
    input {
      display: none;
      &:checked + label {
        border-color: #4DA1FF;
        color: #4DA1FF;
        span {
          &::before {
            border-color: #4DA1FF;
            background-color: #4DA1FF;
          }
          &::after {
            border-color: #FFF;
          }
        }
      }
    }
    label {
      display: flex;
      min-height: 24px;
      padding: 12px 16px;
      border: 1px solid #E4E7EB;
      border-radius: 4px;
      background: #FFF;
      word-break: break-all;
      cursor: pointer;
      transition: .2s;
      span {
        display: block;
        position: relative;
        padding-left: 40px;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        &::before,
        &::after {
          position: absolute;
          content: "";
          transition: .2s;
        }
        &::before {
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          width: 24px;
          height: 24px;
          border: 2px solid #818181;
          border-radius: 50%;
          background-color: #FFF;
        }
        &::after {
          top: 50%;
          left: 7px;
          transform: translateY(-50%) rotate(-45deg);
          width: 10px;
          height: 6px;
          border-left: 2px solid transparent;
          border-bottom: 2px solid transparent;
        }
      }
    }
  }
  &__radio {
    label {
      span::before {
        border-radius: 50%;
      }
    }
  }
  &__checkbox {
    label {
      span::before {
        border-radius: 4px;
      }
    }
  }
  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 280px;
    height: 48px;
    margin: 24px auto 0;
    border-radius: 10px;
    background: $color-accent-primary;
    color: #FFF;
    font-weight: bold;
    font-size: 14px;
    line-height: 1.5;
    text-decoration: none;
  }
  &__link {
    margin-top: 48px;
    text-decoration: underline;
    text-align: center;
  }
}
</style>
